import { render, staticRenderFns } from "./InstallationManagementSoftwarePage.vue?vue&type=template&id=285c5116&"
import script from "./InstallationManagementSoftwarePage.vue?vue&type=script&lang=js&"
export * from "./InstallationManagementSoftwarePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports